import { render, staticRenderFns } from "./_TemplateTextOption.vue?vue&type=template&id=4998909f"
import script from "./_TemplateTextOption.vue?vue&type=script&lang=js"
export * from "./_TemplateTextOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports